module.exports = __webpack_public_path__ + "static/media/no_4.516f9272.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/HomeFavourableRoll/images/no_4.png
// module id = 380
// module chunks = 0